import { TGetLibraryProblemsParams } from '../../types/Interviews/problem.types';
import { HTTP_METHODS } from '../../constants/HttpConstants';
import { sendRequestToServerWithCredentials } from '../../utils/request';

export const getProblemsFromLibrary = (params: TGetLibraryProblemsParams) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.GET,
    url: '/interviews/search/problem/',
    params,
    paramsSerializer: (queryParams) => {
      return Object.entries(queryParams)
        .map((queryParam) => {
          const [paramKey, paramValue] = queryParam;
          if (
            (!paramValue && paramValue !== 0) ||
            (typeof paramValue === 'object' && !paramValue.length)
          )
            return null;
          else if (typeof paramValue === 'object' && paramValue.length) {
            return paramValue
              .map((value: any) => [paramKey, value].join('='))
              .join('&');
          }
          return queryParam.join('=');
        })
        .filter((data) => data)
        .join('&');
    },
  });
};

export const getProblemDetailApi = (problemSlug: string) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.GET,
    url: `/interviews/problem/${problemSlug}/`,
  });
};
